import { useEffect, useState } from "react";
// import logoDark from "/src/assets/Logo/logo-dark.svg";
// import logoLight from "/src/assets/Logo/logo-light.svg";
import logoDark from "@/assets/Navbar/logo.png";
import logoLight from "@/assets/Navbar/light-logo.png";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/store/atoms";
import { useNavigate } from "react-router-dom";

const Logo = () => {
    const navigate = useNavigate();
    const themeAtomValue = useAtomValue(themeAtom);
    const [, setLogoURL] = useState<string>();

    useEffect(() => {
        setLogoURL(
            themeAtomValue === "dark" ? logoDark : logoLight
        );
    }, [themeAtomValue]);

    const handleLogoClick = () => {
        navigate("/");
    };
    
    return(
        <div 
            className="w-[120px] h-[41px] xl:min-w-[134px] xl:min-h-[41px] 2k:min-w-[200px] 2k:min-h-[61px] cursor-pointer"
            onClick={handleLogoClick}
        >
            <img
                src={logoDark}
                alt="urfx logo"
                className="w-full object-cover h-auto"
            />
        </div>
    )
}

export default Logo;